import { memo } from 'react';
import { Link } from 'react-router-dom';
import { localeStore } from 'src/mobx/localesStore';
import OrderBlockItem from 'src/view/screens/OrderScreen/components/OrderBlockItem/OrderBlockItem';
import { AGGREGATORS } from '~/constants/aggregators';
import AggregatorManager from '~/view/components/AggregatorManager/AggregatorManager';
import { useOrderStoreContext } from '~/view/screens/OrderScreen/context';
import getOrderLogPath, { LOGS } from '~/view/screens/OrderScreen/getOrderLogPath';
import './style.scss';

interface ILogsLink {
  path: string;
}

const LogsLink: React.FC<ILogsLink> = (props: ILogsLink): JSX.Element => {
  return (
    <Link to={props.path} className="color-mainblue text-size-18 family-medium">
      {localeStore.t('view_log')}
    </Link>
  );
};

interface IProps {
  orderId?: string;
  aggregatorKey?: AGGREGATORS | null;
}

const DetailsLogs: React.FC<IProps> = (props: IProps): JSX.Element | null => {
  if (!props.orderId) return null;

  const { store: orderStore } = useOrderStoreContext();

  return (
    <div className="d-flex flex-column">
      <OrderBlockItem title="technical_log" className="details-logs__item" titleClassName="details-order__item-title">
        <LogsLink path={getOrderLogPath(orderStore.parentStore, LOGS.TECHNICAL, props.orderId)} />
      </OrderBlockItem>
      <OrderBlockItem title="status_log" titleClassName="details-order__item-title">
        <LogsLink path={getOrderLogPath(orderStore.parentStore, LOGS.STATUSES, props.orderId)} />
      </OrderBlockItem>
      <AggregatorManager aggregator={props.aggregatorKey} sectionName="transaction_logs">
        <OrderBlockItem title="transactions_log" titleClassName="details-order__item-title">
          <LogsLink path={getOrderLogPath(orderStore.parentStore, LOGS.TRANSACTIONS, props.orderId)} />
        </OrderBlockItem>
      </AggregatorManager>
      <OrderBlockItem title="order_content_log" titleClassName="details-order__item-title">
        <LogsLink path={getOrderLogPath(orderStore.parentStore, LOGS.CONTENTS, props.orderId)} />
      </OrderBlockItem>
    </div>
  );
};

export default memo(DetailsLogs);
